import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
    FaArrowRight
} from "react-icons/fa";

// import ContactFromWrapper, {  FormWrapper } from './contact.style';

const FinshotsDailySection = (props) => {
    const contactRef = useRef("contact");
    return (
        <div className="SectionMainWrapper" ref={contactRef}>
            <div className="container-daily-finshots">
                <div className="containerClass">
                    <h1 className='h1'>
                    Get more updates from Finshots everyday
                    </h1>
                    <div>
                        <button className='button' onClick={() => window.open(`https://finshots.in/?utm_source=finshotsMarkets&utm_medium=webArticleCTA`)}>
                            Subscribe to Finshots Daily
                        </button>
                    </div>
                    <br />
                    <span style={{ fontSize: `1.2em` }}>Join 1,25,000+ subscribers</span>
                    
                </div>
            </div>
        </div>
    );
};

FinshotsDailySection.propTypes = {
    sectionWrapper: PropTypes.object,
    secTitleWrapper: PropTypes.object,
    row: PropTypes.object,
    contactForm: PropTypes.object,
    secHeading: PropTypes.object,
    secText: PropTypes.object,
    button: PropTypes.object,
    note: PropTypes.object,
    title: PropTypes.object,
    description: PropTypes.object,
    colornote: PropTypes.object,
};

FinshotsDailySection.defaultProps = {
    sectionWrapper: {
        id: "contact_section",
        as: "section",
        pt: ["8px", "80px", "80px", "80px"],
        pb: ["0", "80px", "80px", "80px", "80px"],
    },
    secTitleWrapper: {
        mb: ["0px", "0px", "0px"],
        p: ["0 15px", 0, 0, 0, 0],
    },
    secText: {
        as: "span",
        display: "block",
        textAlign: "center",
        fontSize: `${2}`,
        letterSpacing: "0.15em",
        fontWeight: `${6}`,
        color: "primary",
        mb: `${3}`,
    },
    secHeading: {
        textAlign: "center",
        fontSize: [`${6}`, `${8}`],
        fontWeight: "400",
        color: "headingColor",
        letterSpacing: "-0.025em",
        mb: `${0}`,
    },
    row: {
        flexBox: true,
        justifyContent: "center",
    },
    contactForm: {
        width: [1, 1, 1, 1 / 2],
    },
    button: {
        type: "button",
        fontSize: `${2}`,
        fontWeight: "600",
        borderRadius: "4px",
        pl: "22px",
        pr: "22px",
        colors: "primaryWithBg",
        height: `${4}`,
    },
    note: {
        fontSize: "16px",
        fontWeight: "400",
        color: "#525f7f",
        lineHeight: "28px",
        mb: ["25px", "25px", "30px", "30px", "45px"],
        textAlign: ["center", "center"],
    },
    colornote: {
        fontSize: "16px",
        fontWeight: "500",
        color: "rgb(106, 82, 253)",
        lineHeight: "28px",
        mb: ["25px", "25px", "30px", "30px", "45px"],
        textAlign: ["center", "center"],
    },
    title: {
        content: "Join 1,25,000+ subscribers",
        fontSize: ["20px", "26px", "30px", "36px", "40px"],
        lineHeight: ["30px", "32px", "40px", "50px", "55px"],
        fontWeight: "700",
        color: "#32325d",
        letterSpacing: "-0.010em",
        mb: "20px",
        textAlign: ["center", "center"],
    },

    description: {
        content: "Just one article every day. Pinky promise 🙌",
        fontSize: "16px",
        fontWeight: "400",
        color: "#525f7f",
        lineHeight: "28px",
        mb: ["25px", "25px", "30px", "30px", "45px"],
        textAlign: ["center", "center"],
    },
};

export default FinshotsDailySection;
